var chart = {
  option : {
      tooltip : {
          show: true,
          formatter: "{a} <br/>{b} : {c} ({d}%)"
      },
      legend: {
          orient : 'vertical',
          x : 'left',
          data:['PDIP','GERINDRA','GOLKAR','PSI','PAN','PKS','PKB']
      },
      toolbox: {
          show : true,
          feature : {
              //mark : {show: true},
              //dataView : {show: true, readOnly: false},
              //restore : {show: true},
              saveAsImage : {show: true, title:'Pict'}
          }
      },
      calculable : true,
      series : []
  },
  series : {
      name:'Dapil 2',
      type:'pie',                           
      radius : [50, 70],
      center: ['65%', '50%'],
      itemStyle : {
          normal : {
              label : {
                  show : false
              },
              labelLine : {
                  show : false
              }
          },                      
      },
      data:[],
  }
}; 

export default chart;
